import request from "../utils/request";

const userApi = {
  // 发送验证码
  sendCode(phone) {
    return request({
      url: '/api/sendre.php',
      method: 'get',
      params: { 
        t: 'pwd',
        phone 
      }
    })
  },
  
  // 注册
  register(data) {
    return request({
      url: '/api/auth/register',
      method: 'post',
      data
    })
  },
  
  // 登录
  login(data) {
    return request({
      url: '/member/index_do.php?fmdo=login',
      method: 'post',
      data
    })
  },
  login2(data) {
    return request({
      url: '/member/index_do.php?fmdo=login',
      method: 'post',
      data
    })
  },
  // 第三方授权
  author(params, data) {
    return request({
      url: '/user/author',
      method: 'get',
      params,
      data
    })
  },
  
  // 获取用户资料
  profile(params, data) {
    return request({
      url: '/user/profile/other',
      method: 'get',
      params,
      data
    })
  },
  
  // 获取用户资料(新接口)
  getUserProfile() {
    return request({
      url: '/api2/user/profile',
      method: 'get'
    })
  }
}

export { userApi }
export default userApi
